// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"k5-z"};